var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilledCheckedDatabase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.75C9.815 0.75 12.5 2.0925 12.5 3.75C12.5 5.4075 9.815 6.75 6.5 6.75C3.185 6.75 0.5 5.4075 0.5 3.75C0.5 2.0925 3.185 0.75 6.5 0.75ZM0.5 5.25C0.5 6.9075 3.185 8.25 6.5 8.25C9.815 8.25 12.5 6.9075 12.5 5.25V7.56L11.75 7.5C9.8075 7.5 8.15 8.73 7.52 10.455L6.5 10.5C3.185 10.5 0.5 9.1575 0.5 7.5V5.25ZM0.5 9C0.5 10.6575 3.185 12 6.5 12H7.25C7.25 12.7875 7.4525 13.53 7.8125 14.175L6.5 14.25C3.185 14.25 0.5 12.9075 0.5 11.25V9ZM11 14.31L8.9375 12.06L9.8075 11.19L11 12.375L13.6925 9.69L14.5625 10.7475L11 14.31Z",
    fill: "#64A4A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledCheckedDatabase);
export default __webpack_public_path__ + "static/media/FilledCheckedDatabase.8722eebae82c5546ffbf96704ae331dc.svg";
export { ForwardRef as ReactComponent };